import React, {useCallback, useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {NavBar} from 'Components/Nav/NavBar';
import s from './styles/Blogs.module.scss';
import Footer from "./Footer";
import {getDeviceId, isLoggedIn, SessionContext} from "../../Utils/sessions";
import {Root} from "../../Api/Root";
import SideBar from "../../Components/Nav/SideBar";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {useScroll} from "../../Utils/helpers";
import {logElementInteraction} from "../../Api/Utils/referral";

export const BLOG_TOPICS = ['Artificial Intelligence', 'Technology', 'Higher Education', 'Choosing a college', 'College Application', 'Financial Aid', 'Loans', 'Scholarships', 'Preparation', 'Student Life', 'Study Skills', 'Graduate School', 'Career Development', 'Internships', 'Job Market', 'Transferring', 'Future of Learning']

export const BACKUP_BLOGS = [
    {
        byline: "Samantha Steff",
        university: "Columbia University",
        description: "Columbia University junior, Samantha Seiff, reflects on her experience as a college student in the Big Apple.",
        uri: "college-life-in-nyc",
        title: "College Life in NYC",
        coverUrl: "https://cdn.cassy.dev/columbia.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "",
        university: "",
        description: "College student shares their thoughts on attending community college and the transfer process.",
        uri: "transfer",
        title: "Community College to Four Year University",
        coverUrl: "https://cdn.cassy.dev/transfer.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "",
        university: "University of California, San Diego",
        description: "Top 12 must have items for Freshman year",
        uri: "college-essentials",
        title: "12 College Essentials",
        coverUrl: "https://cdn.cassy.dev/ucal.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "Briana Buckley",
        university: "Rice University",
        description: "Graduate student Brianna gives her take on the pros and cons of attending grad school.",
        uri: "grad-school",
        title: "Is Grad School Right for Me?",
        coverUrl: "https://cdn.cassy.dev/scale.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "Anonymous",
        university: "",
        description: "Student breaks down the steps you can take as a high schooler, to help get into college.",
        uri: "beating-the-odds",
        title: "How to Beat the Odds",
        coverUrl: "https://cdn.cassy.dev/decision-fork.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    }
]

export const BACKUP_BLOG_CONTENT = {
    'college-life-in-nyc': {
        tableOfContents: [{id: '', title: ''}, {id: '', title: ''}],
        title: 'College Life in NYC',
        author: {avatar: '', avatarAlt: '', name: 'Samantha Steff'},
        dateString: 'may 10, 2025',
        duration: '12 min',
        heroImageUrl: 'https://cdn.cassy.dev/columbia.png',
        paragraphs: [
            {
                heading: {id: 'introduction', title: 'Introduction'},
                text: 'Life as a student in New York City has been so darn peachy that I decided ' +
                    'to write an article all about it. Like many students who wind up at Columbia ' +
                    'University, I did not want to wait until after I finished my undergraduate education ' +
                    'to experience life in a major city. The pace, availability of opportunity, and general ' +
                    'excitement of life in New York City is unmatched. That being said, many students ' +
                    'considering a city school are understandably concerned about the efficacy of student ' +
                    'life in one of the cultural capitals of the world.'
            },
        ],
    },
    'transfer': {},
    'college-essentials': {},
    'grad-school': {},
    'beating-the-odds': {},
}


const BlogTile = ({blog}) => {
    const [loading, setLoading] = useState(true)

    const handleClick = () => {
        if (blog?.uri) {
            window.location.href = `${window.location.href.split('/')[0]}/blog/posts/${blog.uri}`;
        }
    }

    return (
        <>
            {blog ?
                <>
                    <div className={s.desktop}>
                        <div className={`${s.blogTile} mb-5`} onClick={handleClick}>
                            <div className={s.grid}>
                                <div className={s.blogTileImageContainer}>
                                    <img className={s.blogTileImage} src={blog.coverUrl} alt={'blog cover'}
                                         onLoad={() => setLoading(false)}/>
                                    {loading &&
                                        <div className={`${s.blogTileImagePlaceholder} ${s.shimmerBg}`}
                                             style={{zIndex: 0}}/>}
                                </div>

                                <div className={s.blogInfo}>
                                    <p>{blog.byline || "Anonymous"} | {blog.university || "Unknown University"}</p>
                                    <div className={s.blogTileTitle}><strong>{blog.title}</strong></div>
                                    <p>{blog.description}</p>
                                    <div>
                  <span style={{
                      height: '200px',
                      borderRadius: '20px',
                      objectFit: 'cover',
                      width: '100%'
                  }}>{blog.readTime} minute read</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${s.mobile} mb-4`}>
                        <div role={'link'}
                             onClick={handleClick}
                             className={s.blogTile}>
                            <img className={s.blogTileImage} src={blog.coverUrl} alt={'blog cover'}
                                 onLoad={() => setLoading(false)}/>
                            <p className={`mb-1`}>{blog.byline || "Anonymous"} | {blog.university || "Unknown University"}</p>
                            <div className={s.blogInfo}>
                                <p className={s.blogTileTitle}>
                                    {blog.title}
                                </p>
                                <p className={s.blogTileSubtitle}>
                                    {blog.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </> :
                <>
                    <div>
                        <div className={`${s.blogTile} mb-5`} onClick={handleClick}>
                            <div className={s.grid}>
                                <div className={`${s.blogTileImage} ${s.shimmerBg}`}
                                     style={{
                                         height: '200px',
                                         borderRadius: '20px',
                                         objectFit: 'cover',
                                         width: '100%'
                                     }}/>
                                <div>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={`${s.subtitlePlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

BlogTile.propTypes = {
    blog: PropTypes.shape({
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        byline: PropTypes.string,
        coverUrl: PropTypes.string.isRequired,
        university: PropTypes.string,
        dateString: PropTypes.string,
        readTime: PropTypes.number,
        likes: PropTypes.number,
        commentCount: PropTypes.number,
        description: PropTypes.string,
        audioUrl: PropTypes.string,
        audio: PropTypes.bool,
        timestamp: PropTypes.number,
    }),
};

export const BlogPageDisplay = () => {
    const {session} = useContext(SessionContext);
    const [blogs, setBlogs] = useState(undefined)
    const [resetFilter, setResetFilter] = useState(0)
    const [getBlogPostsRequest, setGetBlogPostsRequest] = useState({deviceId: getDeviceId(), userId: session?.id})
    const [searchBarPlaceHolder, setSearchBarPlaceholder] = useState('Search for a blog')

    const isScrolled = useScroll(5)

    let counter = 0;

    useEffect(() => {
        const placeHolderOptions = [
            `"A student studying computer science"`,
            `"A junior at a college near me"`,
            `"Someone who's interested in art"`,
            `"A student athlete"`,
            `"Some who's also shy, like me"`]

        const intervalId = setInterval(() => {
            counter++;
            setSearchBarPlaceholder(placeHolderOptions[counter % 5]);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [counter]);

    function handleTopicUpdate(topic) {
        setBlogs(undefined)
        if (topic?.length === 0) {
            setGetBlogPostsRequest((prevState) => ({...prevState, query: undefined, topic: undefined}));
        } else {
            setGetBlogPostsRequest((prevState) => ({...prevState, query: undefined, topic: topic}));
        }
    }

    function searchBlogs(searchQuery) {
        if (searchQuery?.length > 0) {
            setResetFilter(resetFilter + 1)
            setGetBlogPostsRequest((prevState) => ({...prevState, query: searchQuery, topic: undefined}));
        }
    }

    const getBlogPosts = useCallback(() => {
        Root.bloggingApi.getBlogPosts(getBlogPostsRequest).then((res) => {
            setBlogs(res.data)
        }).catch(() => {
            setBlogs(BACKUP_BLOGS)
        })
    }, [getBlogPostsRequest]);

    useEffect(() => {
        getBlogPosts()
    }, [getBlogPosts])

    useEffect(() => {
        logElementInteraction( {
            elementId: isLoggedIn(session) ? 'blogs::all::authenticated' : 'blogs::all::public',
            type: 'VIEW',
            deviceId: getDeviceId(),
            data: localStorage.getItem('userInfo'),
            source: 'WEB'
        }).then(() => {}).catch(() => {});
    }, [session])

    if (isLoggedIn(session)) {
        return <>
            <SideBar session={session} title={"Blogs"}
                     placeholder={searchBarPlaceHolder}
                     searchBarSuggestions={[]}
                     onSearchQueryChange={() => {}}
                     onSearch={searchBlogs}>
                <div className={s.blog}>
                    <BlogFinder blogs={blogs} onTopicUpdate={handleTopicUpdate} resetFilter={resetFilter}/>
                </div>
            </SideBar>
        </>
    }

    return <>
        <div className={s.blog}>
            <div className={`${s.navBarContainer} ${isScrolled ? s.navBarScrolled : ''}`}>
                <NavBar dark={true}/>
            </div>
            <div className={`${s.blogsHeader}`}>
                <div className={`${s.blogsHeaderText}`}>
                    <h1><strong>Blogs</strong></h1>
                    <h3 className={s.subheader}>Curated articles to answer some of your burning college questions</h3>
                </div>
            </div>
            <div className={'mt-3'}>
                <BlogFinder blogs={blogs} onTopicUpdate={handleTopicUpdate} resetFilter={resetFilter}/>
            </div>
        </div>
        <Footer/>
    </>
}

function BlogFinder({blogs, onTopicUpdate, resetFilter}) {
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        if (onTopicUpdate) {
            onTopicUpdate(e?.target?.value.replaceAll(' ', '-'))
        }
        setFilterOpen(false)
    }

    return (
        <div className={s.blogFinder}>
            <main className={s.blogListContainer}>
                <BlogList blogs={blogs}/>
            </main>
            <div className={s.blogFilterContainer}>
                <Card className={s.blogFilterCard}>
                    <Card.Title className={s.blogFilterCardHeader}>
                        <div className={s.blogFilterCardFilterToggle}></div>
                        <div className={s.blogFilterCardTitle}>Recommended Topics</div>
                        <div className={s.blogFilterCardFilterToggle}>
                            <Button className={`btnLink`}
                                    onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                        </div>
                    </Card.Title>
                    <div className={s.mobile}>
                        {filerOpen &&
                            <>
                                <Card.Body className={'my-0'}>
                                    <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`} onClick={updateTopic} value={''}>All topics</Button>
                                    {BLOG_TOPICS.map((blogTopic, idx) =>
                                        <Button key={idx} className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`} onClick={updateTopic} value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                    )}
                                </Card.Body>
                            </>
                        }
                    </div>
                    <div className={s.desktop}>
                        <Card.Body className={'my-1'}>
                            <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`} onClick={updateTopic} value={''}>All topics</Button>
                            {BLOG_TOPICS.map((blogTopic, idx) =>
                                <Button key={idx} className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`} onClick={updateTopic} value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                            )}
                        </Card.Body>
                    </div>
                </Card>
            </div>
        </div>
    )
}

BlogFinder.propTypes = {
    blogs: PropTypes.arrayOf(PropTypes.shape({
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        byline: PropTypes.string,
        coverUrl: PropTypes.string.isRequired,
        university: PropTypes.string,
        dateString: PropTypes.string,
        readTime: PropTypes.number,
        likes: PropTypes.number,
        commentCount: PropTypes.number,
        description: PropTypes.string,
        audioUrl: PropTypes.string,
        audio: PropTypes.bool,
        timestamp: PropTypes.number,
    })),
    onTopicUpdate: PropTypes.func,
    resetFilter: PropTypes.number
};

export const BlogList = ({ blogs }) => {

    return <>
        <div className={`${s.blogsContent} `}>
            {blogs ?
                <>
                    {blogs.length > 0 ?
                        blogs.map((b, idx) => <BlogTile key={idx} blog={b}/>) :
                        <>
                            <div className={'text-center'}><h3>No blogs found</h3></div>
                        </>
                    }
                </> :
                <>
                    <BlogTile />
                    <BlogTile />
                    <BlogTile />
                </>
            }
        </div>
    </>
}

BlogList.propTypes = {
    blogs: PropTypes.arrayOf(PropTypes.shape({
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        byline: PropTypes.string,
        coverUrl: PropTypes.string.isRequired,
        university: PropTypes.string,
        dateString: PropTypes.string,
        readTime: PropTypes.number,
        likes: PropTypes.number,
        commentCount: PropTypes.number,
        description: PropTypes.string,
        audioUrl: PropTypes.string,
        audio: PropTypes.bool,
        timestamp: PropTypes.number,
    }))
};
